import React from 'react'
import { Row, Col, Toast, ToastContainer } from 'react-bootstrap'

const ToastBox = ({ handleToast, toastType, toastMessage }) => {
    const bgcolor = {
        "Error": "danger",
        "Success": "success",
        "Warning": "warning"
    }
    return (
        <Row>
            <Col xs={6}>
                <div
                    aria-live="polite"
                    aria-atomic="true"
                    style={{ minHeight: '240px' }}
                >
                    <ToastContainer className="p-3 toast-container position-fixed" position={"bottom-center"}>
                        <Toast bg={bgcolor[toastType]} onClose={() => handleToast(false)} show={true} delay={4000} autohide>
                            <Toast.Header>
                                <strong className="me-auto">{toastType}</strong>
                            </Toast.Header>
                            <Toast.Body style={{ color: 'white', fontWeight: 'bold' }}>{toastMessage}!</Toast.Body>
                        </Toast>
                    </ToastContainer>
                </div>
            </Col>
        </Row>
    )
}

export default ToastBox